import React from 'react';
import QrReader from '../react-qr-reader';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import { ReadPropsQRReassign } from '../../../../home/helper/request.props.js';
import { PresenterReadQRReassign } from '../../../../home/presenter.js'

import Request from '../../../../config/Request.js';

export default class ModalQRScanner extends React.Component {
	constructor(){
		super()
		this.delay 		= 500
		this.initialState = {
			delay 	 	: this.delay,
			allowed  	: true,
			scanning 	: true,
			legacyMode 	: false,
			type 		: null,
			result 	 	: 'Loading...',
		}
		this.state 		= Object.assign({}, this.initialState);
		this.newState 	= {};
		this.isSuccess  = false;

		this.handleScan = this.handleScan.bind(this);
		this.handleError = this.handleError.bind(this);
		this.openImageDialog = this.openImageDialog.bind(this);
		this.onImageLoad = this.onImageLoad.bind(this);
		this.willMount = this.willMount.bind(this);
		this.markAsExist = this.markAsExist.bind(this);
		this.onMarkAsExistSuccess = this.onMarkAsExistSuccess.bind(this);
		this.onMarkAsExistFailed = this.onMarkAsExistFailed.bind(this);
		this.onReadAssetDetailSuccess = this.onReadAssetDetailSuccess.bind(this);
		this.onReadAssetDetailFailed = this.onReadAssetDetailFailed.bind(this);
		this.onReadQRReassignSuccess = this.onReadQRReassignSuccess.bind(this);
		this.onReadQRReassignFailed = this.onReadQRReassignFailed.bind(this);
	};

	handleScan(result){
		if(result){
			if (this.props.scanType === "asset"){
				/*  = = = = = asset = = = = =  */
				try{
					const newResult = JSON.parse(result);
					if (newResult.hasOwnProperty('type')){
						switch (newResult.type) {
							case 'asset':
								this.onReadAssetDetail(newResult.type, newResult.value);
								break;
							case 'confirmation':
								this.onReadQRReassign(newResult.value);
								break;
							default: break;
						}
						this.newState = {type : newResult.type}
					}else if(typeof(newResult) === 'number'){
						this.onReadAssetDetail('tag', newResult.toString());
						this.newState = {type : 'tag'}
					}else{
						return
					}
				}catch(err){
					this.onReadAssetDetail('tag', result);
					this.newState = {type : 'tag'}
				}
				this.newState.delay = false
			} else if(this.props.scanType === "stock_take"){
				/* = = = =  = stock take = = = =  =*/
				try{
					const newResult = JSON.parse(result)
					if(newResult.hasOwnProperty('type')){
						this.markAsExist(newResult.value)
						this.newState = {type : newResult.value}
					}else if(typeof(newResult) === 'number'){
						this.markAsExist(newResult.toString())
						this.newState = {type : 'tag'}
					}
				}catch(err){
					this.markAsExist(result)
					this.newState = {type : 'tag'}
				}
			}
			this.newState.scanning = false
			this.setState(this.newState)
		}
	};

	handleError(err){
		if (err){
			if(err.name === 'OverconstrainedError'){
				toast.error(err.name + ' : ' + err.constraint)
			}else{
				toast.error(err.name)
			}

			if(err.name === 'NotAllowedError'){
				this.newState.allowed = false;
			}else{
				this.newState.legacyMode = true;
			}

			this.newState.scanning = false;
			this.newState.delay = false;
			this.setState(this.newState);
		}else{
			return
		}
		// setTimeout(this.props.closeModal, 2500);
	};

	openImageDialog(){
		this.refs.qrReader.openImageDialog();
	}

	isFound(isFound, msgResult, scannedResult = null){
		if(isFound){
			if(this.props.scanType === 'asset'){
				this.newState = {
					result 	 : msgResult + ' Found!',
					scanning : false,
					delay 	 : false
				};
			}else if(this.props.scanType === 'stock_take'){
				this.newState = {
					result 	 : msgResult,
					scanning : true
				}
			}
			this.setState(this.newState);
		}else{
			if(this.props.scanType === 'asset'){
				this.setState({
					result :  msgResult + ' Not Found! Result : ' + scannedResult
				})
				this.newState = {
					scanning : false,
					delay 	 : false
				}
				setTimeout(() => this.setState(
					this.newState,
					this.setState({ result : 'Closing...' })
				), 2500);
			}else{
				return
			}
		}
	};

	onImageLoad(){
		this.setState({
			scanning : true,
			delay    : this.delay
		})
	};

	markAsExist(tag){
		const payload = {
		  Tag  		: tag,
		  StockTake : this.props.data.stockTake
		}

		Request(
		  "post",
		  "mark-as-exist",
		  {Authorization: "Bearer " + this.props.UserReducer.token},
		  payload,
		  [],
		  this.onMarkAsExistSuccess,
		  this.onMarkAsExistFailed,
		)
	}

	onMarkAsExistSuccess(response){
		toast.success("Asset Exist!")
		this.isFound(true, "Asset Exist!")
		this.props.onSuccess(this.state.type, response.data)
	}

	onMarkAsExistFailed(err){
		toast.error(err.response.data.detail)
		this.isFound(true, err.response.data.detail)
	}

	onReadAssetDetail(type, value){
		// PresenterReadBookedAsset(
	 //    	ReadPropsBookedAsset(
	 //    		type, this,
	 //    		this.onReadAssetDetailSuccess.bind(this),
	 //    		this.onReadAssetDetailFailed.bind(this),
	 //    		'field=&search=', 'ordering=-SortDate,-CreatedTime',
	 //    		1, value
	 //    	)
	 //  	);
	 	let data = {}
	 	if (type === 'asset'){
	 		data = {search : value}
	 	}else{
	 		data = {tag : value}
	 	}
	  	Request(
	  		"get", "read-asset-global",
	  		{Authorization: "Bearer " + this.props.UserReducer.token},
	  		data, [],
	  		this.onReadAssetDetailSuccess,
    		this.onReadAssetDetailFailed,
    		value
	  	)
	};

	onReadAssetDetailSuccess(response, scanValue){
		if(response.data.results[0]){
			this.isFound(true, 'Asset / Tool');
			this.props.closeModal();
			if(!this.isSuccess){
				this.props.onSuccess(this.state.type, response.data.results[0]);
				this.isSuccess = true;
			}
		}else{
			if(this.state.type === 'tag' && this.props.UserReducer.props.isAdmin){
				this.props.closeModal();
				this.props.openModalInsertTag(scanValue);
			}else{
				this.isFound(false,'Asset / Tool', scanValue)
				setTimeout(this.props.closeModal, 3000)
			}
		}
	};

	onReadAssetDetailFailed(response, scanValue){
		// const alias = scanValue;
		this.isFound(false,'Asset / Tool', scanValue);
		setTimeout(this.props.closeModal, 3000)
	};

	onReadQRReassign(alias){
		PresenterReadQRReassign(
			ReadPropsQRReassign(
				'Read', this,
				this.onReadQRReassignSuccess,
				this.onReadQRReassignFailed,
				alias
			)
		);
	}

	onReadQRReassignSuccess(params, response){
		if(response.data){
			this.isFound(true, 'Confirmation');
			this.props.closeModal();
			if(!this.isSuccess){
				this.props.onSuccess(this.state.type, response.data);
				this.isSuccess = true;
			}
		}else{
			this.isFound(false, 'Confirmation', params.data.Alias);
			setTimeout(this.props.closeModal, 3000)
		}
	}

	onReadQRReassignFailed(params, response){
		this.isFound(false, 'Confirmation', params.data.Alias)
		setTimeout(this.props.closeModal, 3000)
	}

	renderQRScanner(){
		if (this.state.allowed){
			return(
				<div className="text-center">

					<QrReader
						delay={this.state.delay}
						legacyMode={this.state.legacyMode}
						onError={this.handleError}
						onScan={this.handleScan}
						onImageLoad={this.onImageLoad}
						ref='qrReader'
					/>

				    {!this.state.legacyMode ?
				    	<span className="text-muted">Place the Code inside the frame</span>
				    	:
					    <div className="m-top-15">
					    	<span style={{fontWeight: 700}}>
					    		Your Browser is not Supported!
					    	</span>
					    	<br />
					    	<span style={{fontWeight: 600}}>
					    		If You're using iPhone this feature works on Safari iOS 11 above.
					    	</span>
					    	<br />
					    	<span style={{fontWeight: 600}}>
					    		<button
					    			className="btn btn-primary"
					    			onClick={this.openImageDialog}
					    			style={{padding: "0.2rem 1rem"}}
					    		>
					    			Click Here
					    		</button>
					    		&nbsp; to Take Images
					    	</span>
					    </div>
					}

				</div>
			)
			// }
		}else {
			return(
				<div className="card-block align-center NoDataContainer">
				  <div>
				    <span><i className="fa fa-5x fa-video-camera"></i></span><br/>
				    <span><b>Please Allow Camera Permission on This Browser</b></span><br/>
				  </div>
				</div>
			)
		}
	};

	renderResultField(){
		if (this.state.scanning){
			return (<span><i className="fa fa-cog fa-spin fa-fw" />&nbsp;<i>Scanning . . .</i></span>)
		}else if (!this.state.allowed || this.state.legacyMode){
			return ('No Result')
		}else{
			return (this.state.result)
		}
	};

	willMount(){
		this.setState(this.initialState)
		this.isSuccess = false;
	};

	willUnMount(){
		// this.setState(this.initialState)
	};

	render(){
		return(
			<Modal
				isOpen	= {this.props.isOpen}
				toggle 	= {this.props.closeModal}
				// onExit	= {this.willUnMount.bind(this)}
				onEnter = {this.willMount}
			>
				<ModalHeader toggle={this.props.closeModal}><i className="fa fa-qrcode"></i> QR Scan</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="form-group col-sm-12">
							{/*<label htmlFor="Name" className="required" >Name</label>*/}
								{/*<div className="diode">
									<div className="laser"></div>
								</div>*/}
							{this.renderQRScanner()}
						</div>
						<div className="form-group col-sm-12">
							<label htmlFor="Tag">Result :</label>
							<div style={{ fontSize : '1.1em'}}>
								{this.renderResultField()}
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="danger" onClick={this.props.closeModal}>Close</Button>
				</ModalFooter>
			</Modal>
		)
	};
}



// WEBPACK FOOTER //
// ./src/App/qrreader/helper/component/Modal/ModalQRScanner.js